module.exports = __webpack_public_path__ + "static/media/image3.09d68bc1.JPG";